export enum CoverageName {
  DeclineCoverage = 'Decline Coverage',
  Unprotected = 'Unprotected'
}
